import * as _ from 'lodash';

export function extractMissionValues<T>(
  item: any,
  options: string[],
  missionEnum: any,
): T[] {
  let missionValues: T[] = item.missionValues || [];

  options.forEach(option => {
    if (item[option] && !missionValues.includes(missionEnum[option])) {
      missionValues.push(missionEnum[option]);
    }
  });

  return Array.from(new Set(missionValues));
}

export function removeUnusedFields(item: any, fieldsToRemove: string[]): any {
  return _.omit(item, fieldsToRemove);
}

export const productList = {
  missionParticulier: {
    PACK_ESSENTIEL: {
      customField: 'packEssentiel',
      monthlyPrice: 42,
      yearlyPrice: 498,
      yearlyPrestation: true,
      oneTimePayment: false,
      label: 'Pack Essentiel',
      monthlyPriceHT: 420,
      monthlyPriceTTC: 504,
      annuallyPriceHT: 415,
      annuallyPriceTTC: 498,
    },
    PACK_ESSENTIEL_REVENUS_FONCIERS: {
      customField: 'packEssentielRevenusFonciers',
      monthlyPrice: 15,
      yearlyPrice: 180,
      yearlyPrestation: true,
      oneTimePayment: false,
      label: 'Pack revenus fonciers',
      monthlyPriceHT: 150,
      monthlyPriceTTC: 180,
      annuallyPriceHT: 150,
      annuallyPriceTTC: 180,
    },
    PACK_ESSENTIEL_REVENUS_FONCIERS_AVEC_DISPOSITIF: {
      customField: 'packEssentielRevenusFonciersAvecDispositif',
      monthlyPrice: 19,
      yearlyPrice: 225,
      yearlyPrestation: true,
      oneTimePayment: false,
      label: 'Pack revenus fonciers avec dispositif',
      monthlyPriceHT: 190,
      monthlyPriceTTC: 228,
      annuallyPriceHT: 187.5,
      annuallyPriceTTC: 225,
    },
    IRPP: {
      customField: 'irpp',
      label: 'IRPP',
      yearlyPrestation: true,
      oneTimePayment: false,
      monthlyPriceHT: null,
      monthlyPriceTTC: null,
      annuallyPriceHT: null,
      annuallyPriceTTC: null,
    },
    IFI: {
      customField: 'ifi',
      label: 'IFI',
      yearlyPrestation: true,
      oneTimePayment: false,
      monthlyPriceHT: null,
      monthlyPriceTTC: null,
      annuallyPriceHT: null,
      annuallyPriceTTC: null,
    },
    ACCOUNTING_TAKEOVER: {
      customField: 'accountingTakeover',
      label: 'Reprise de comptabilité',
      yearlyPrestation: false,
      oneTimePayment: true,
      monthlyPriceHT: null,
      monthlyPriceTTC: null,
      annuallyPriceHT: null,
      annuallyPriceTTC: null,
    },
  },
  optionParticulier: {
    ADDITIONAL_PROPERTY: {
      label: 'Bien supplémentaire',
      yearlyPrestation: true,
      oneTimePayment: false,
      yearlyPrice: 60,
      monthlyPrice: 5,
      monthlyPriceHT: 50,
      monthlyPriceTTC: 60,
      annuallyPriceHT: 50,
      annuallyPriceTTC: 60,
    },
    TNS_AFFILIATION: {
      label: 'Affiliation TNS',
      yearlyPrestation: false,
      oneTimePayment: true,
      yearlyPrice: 216,
      monthlyPriceHT: 180,
      monthlyPriceTTC: 216,
      annuallyPriceHT: 180,
      annuallyPriceTTC: 216,
    },
  },
  missionLegalEntity: {
    PACK_ESSENTIEL_SCI: {
      customField: 'packEssentielSci',
      label: 'Pack essentiel SCI',
      yearlyPrestation: true,
      oneTimePayment: false,
      monthlyPrice: 50,
      yearlyPrice: 600,
      monthlyPriceHT: 550,
      monthlyPriceTTC: 600,
      annuallyPriceHT: 500,
      annuallyPriceTTC: 600,
    },
    PACK_ESSENTIEL_SCI_IR: {
      customField: 'packEssentielSciIr',
      label: "Pack SCI à l'IR",
      yearlyPrestation: true,
      oneTimePayment: false,
      monthlyPrice: 15,
      yearlyPrice: 180,
      monthlyPriceHT: 150,
      monthlyPriceTTC: 180,
      annuallyPriceHT: 150,
      annuallyPriceTTC: 180,
    },
    PACK_SARL: {
      customField: 'packSarl',
      label: 'Pack essentiel SARL de Famille',
      yearlyPrestation: true,
      oneTimePayment: false,
      monthlyPrice: 50,
      yearlyPrice: 600,
      monthlyPriceHT: 500,
      monthlyPriceTTC: 600,
      annuallyPriceHT: 500,
      annuallyPriceTTC: 600,
    },
    PROVISIONAL_BUDGET: {
      label: 'Budget prévisionnel',
      yearlyPrestation: false,
      oneTimePayment: true,
      yearlyPrice: 300,
      monthlyPriceHT: 250,
      monthlyPriceTTC: 300,
      annuallyPriceHT: 250,
      annuallyPriceTTC: 300,
    },
    SOCIAL_MISSION: {
      customField: 'socialMission',
      label: 'Mission sociale',
      yearlyPrestation: false,
      oneTimePayment: true,
      monthlyPriceHT: null,
      monthlyPriceTTC: null,
      annuallyPriceHT: null,
      annuallyPriceTTC: null,
    },
  },
  optionLegalEntity: {
    ADDITIONAL_PROPERTY: {
      label: 'Bien supplémentaire',
      yearlyPrestation: true,
      oneTimePayment: false,
      yearlyPrice: 60,
      monthlyPrice: 5,
      monthlyPriceHT: 50,
      monthlyPriceTTC: 60,
      annuallyPriceHT: 50,
      annuallyPriceTTC: 60,
    },
  },
};
